module.exports = __webpack_public_path__ + "static/launch-c15968ad234b0169a925db084322d0e5.png";